module.exports = __webpack_public_path__ + "media/images/athletes/4243-75e68f4fbc5b20281cb621797c1f4ec5.png";